import { db } from '../db';
import type { EventRecord, SessionRecord, TrialRecord } from '../types';
import type { ScoredTrial } from '@/domain/scoring/types';

export async function createSession(rec: SessionRecord): Promise<void> {
  await db.sessions.add(rec);
}

export async function finishSession(id: string, patch: Partial<Pick<SessionRecord, 'endedAt' | 'abortedReason' | 'quality' | 'trialCount'>>): Promise<void> {
  await db.sessions.update(id, patch);
}

export async function appendTrials(records: TrialRecord[]): Promise<void> {
  await db.trials.bulkAdd(records);
}

export async function logEvent(e: Omit<EventRecord, 'pk'>): Promise<void> {
  await db.events.add(e);
}

export const getSession = (id: string) => db.sessions.get(id);
export const listSessions = (limit = 50) => db.sessions.orderBy('startedAt').reverse().limit(limit).toArray();
export const listSessionsFor = (participantId: string) =>
  db.sessions.where('[participantId+startedAt]').between([participantId, Dexie_MIN], [participantId, Dexie_MAX]).toArray();
export const getTrials = (sessionId: string) => db.trials.where('[sessionId+trialIndex]').between([sessionId, -Infinity], [sessionId, Infinity]).toArray();

const Dexie_MIN = '';
const Dexie_MAX = '￿';

/** TrialRecord → 스코어링 입력. 조건 라벨과 반응만 남긴다. */
export function toScoredTrials(trials: readonly TrialRecord[]): ScoredTrial[] {
  return trials.map((t) => ({
    trialIndex: t.trialIndex, blockId: t.blockId,
    rt: t.rt, correct: t.correct, timedOut: t.timedOut, aborted: t.aborted,
    congruency: t.congruency, threatSide: t.threatSide, probeSide: t.probeSide, trialType: t.trialType,
  }));
}

export async function deleteSessionCascade(id: string): Promise<void> {
  await db.transaction('rw', db.sessions, db.trials, db.events, db.scores, async () => {
    await db.trials.where('sessionId').equals(id).delete();
    await db.events.where('sessionId').equals(id).delete();
    await db.scores.where('sessionId').equals(id).delete();
    await db.sessions.delete(id);
  });
}
